import angular from 'angular';

import editGeneratedReportsDialog from '../../../dialog.editGeneratedReports';
import selectEditTypeDialog from '../../../dialog.selectEditType';
import reportPackageConfigurationReport from './reportPackageConfigurationReport';
import directive from './report-package-configuration.directive';
import controller from './report-package-configuration.controller';

export default angular
  .module('app.components.reports.packageReports.reportPackageConfiguration', [reportPackageConfigurationReport, editGeneratedReportsDialog, selectEditTypeDialog])
  .directive('prReportPackageConfiguration', directive)
  .controller('PRReportPackageConfigurationController', controller).name;

console.log('app.components.reports.packageReports.reportPackageConfiguration created');
